var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import libraryHelpers from "../helpers/libraryFilters";

function getPropertyText(prop, values) {
  const options = values.map((value) => prop.options.find((o) => o.id === value));
  const labels = options.map((o) => o && o.label).filter((l) => l);
  return labels.join(', ');
}

function getPropertiesTexts(query, properties) {
  return Object.keys(query.filters).reduce((descriptions, propName) => {
    const { values } = query.filters[propName];
    const property = properties.find((p) => p.name === propName);
    if (!values || !property) {
      return descriptions;
    }
    const propText = `${property.label}: ${getPropertyText(property, values)}`;
    return [...descriptions, propText];
  }, []);
}

class SearchDescription extends Component {
  render() {
    const { searchTerm, query, properties } = this.props;
    const descriptions = query && query.filters ? getPropertiesTexts(query, properties) : [];
    const descriptionText = descriptions.length ? ` ${descriptions.join(' - ')}` : '';
    return /*#__PURE__*/(
      _jsx("span", {}, void 0,
      searchTerm,
      descriptionText
      ));

  }
}

SearchDescription.defaultProps = {
  query: undefined
};







function mapStateToProps({ templates }, { query }) {
  const properties =
  query && query.filters ?
  libraryHelpers.URLQueryToState(query, templates.toJS()).properties :
  [];
  return {
    properties
  };
}

export { SearchDescription, mapStateToProps };
export default connect(mapStateToProps)(SearchDescription);